import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { Condition, Practitioner, Role, Speciality } from 'src/models';
import { api } from 'src/services';

export type UseGetPractitionerDetailsParams = {
  practitionerId: string;
};

export type GetPractitionerDetailsResponse = {
  condition_details: (Pick<
    Condition,
    | 'appointment_type'
    | 'condition_name'
    | 'condition_type'
    | 'is_deleted'
    | 'specialty_id'
  > & {
    condition_id: Condition['id'];
  })[];
  practitioner_details: Pick<Practitioner, 'practitioner_id' | 'full_name'> & {
    emails: string;
    is_shown: boolean;
    org_uuid: string;
    role_id: number;
  };
  role_details: Role;
  frontegg_roles: string[];
  specialty_details: Speciality;
};

export type UseGetPractitionerDetailsOptions = Pick<
  UseQueryOptions<any>,
  'enabled'
>;

export const useGetPractitionerDetails = (
  params: UseGetPractitionerDetailsParams,
  options?: UseGetPractitionerDetailsOptions
) => {
  return useQuery({
    queryKey: ['practitionerDetails', params.practitionerId],
    queryFn: () =>
      api
        .post<GetPractitionerDetailsResponse>(`/practitioner_details`, {
          practitioner_id: params.practitionerId,
        })
        .then((res) => res.data),
    ...options,
  });
};
